// src/config/products.js
// 所有产品模块的数据配置

// 图片基础路径（使用 require 或直接字符串，这里用字符串方便维护）
// 实际图片放在 src/assets/images/ 下
const imgPath = (name) => require(`@/assets/images/SXVE-AI/${name}`);
const imageMap = {
    'AI-1': '1.png',
    'AI-2': '2.png',
    'AI-3': '3.png',
    'XPRO-1': '4.png',
    'XPRO-2': '5.png',
    'XPRO-3': '6.png',
    'XPRO-4': '7.png',
    'XPRO-5': '8.png',
    'XPRO-6': '9.png',
    'Other': '10.png'
};
// 辅助函数：根据产品名称获取图片路径
const getImage = (productName) => imgPath(imageMap[productName] || 'default.png');
export const heroData = {
    videoSrc: 'https://cdn.pixabay.com/video/2023/07/12/172606-844610219_large.mp4', // 可替换
    poster: '@/assets/images/poster.jpg',
    typedStrings: ['Future', 'Embodied AI', 'Intelligent Robots'],
    subtitle: 'A global platform leading the new era of embodied intelligence',
    ctaLink: '/introduction',
};

// 产品网格 (AI-1)
export const productGridData = {
    image: getImage('AI-1'),
    alt: 'product',
    title: 'AI-1',
    description: 'Educational Robot',
    link: '/robotics/education',
    aosDelay: 0,
};

// 特色分割 (AI-2)
export const featureSplitData = {
    image: getImage('AI-2'),
    altText: 'service',
    captionTitle: 'AI-2',
    captionDesc: 'Basic Service Robot',
    captionLink: '/base',
    title: 'AI-2',
    buttonLink: '/robotics/base',
    buttonText: 'Learn More',
    aosDelay: 0,
};

// 苹果风格大模块列表 (AI-3, XPRO-1)
export const appleModulesData = [
    {
        title: 'AI-3',
        description: 'Restaurant Delivery Robot',
        link: '/robotics/restaurant',
        image: getImage('AI-3'),
        delay: 0,
    },
    {
        title: 'XPRO-1',
        description: 'Commercial Service Robot',
        link: '/company/businessservice',
        image: getImage('XPRO-1'),
        delay: 100,
    },
];

// 双栏模块列表 (每组两个产品)
export const dualWrappersData = [
    {
        left: {
            title: 'XPRO-2',
            description: 'Premium Service Robot',
            link: '/robotics/highservice',
            image: getImage('XPRO-2'),
        },
        right: {
            title: 'XPRO-3',
            description: 'Industrial Robot',
            link: '/robotics/industrial',
            image: getImage('XPRO-3'),
        },
        leftBg: '#f5f5f7',
        rightBg: '#ffffff',
        aos: 'fade-right',
        delay: 0,
    },
    {
        left: {
            title: 'XPRO-4',
            description: 'Large-Scale Automation Robot',
            link: '/robotics/large-automation',
            image: getImage('XPRO-4'),
        },
        right: {
            title: 'XPRO-5',
            description: 'Premium Service Robot',
            link: '/robotics/humanoidrobot',
            image: getImage('XPRO-5'),
        },
        leftBg: '#ffffff',
        rightBg: '#f5f5f7',
        aos: 'fade-left',
        delay: 0,
    },
    {
        left: {
            title: 'XPRO-6',
            description: 'Basic Service Robot',
            link: '/robotics/medicalrobot',
            image: getImage('XPRO-6'),
        },
        right: {
            title: 'Other',
            description: 'Other Robot',
            link: '/robotics/industrial',
            image: 'https://www.xael-ai.net/images/13.png',
        },
        leftBg: '#f5f5f7',
        rightBg: '#ffffff',
        aos: 'fade-up',
        delay: 0,
    },
];